import {Component, NgZone} from "@angular/core";

import {ModalConfig} from "../services/notification/modal.config";
import {EventBus} from "../event/EventBus";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";

import {BugsnagLoggingService} from "../services/logging/bugsnag-logging.service";
import {PIPELINE_API_STATUS, PipelineSaveEvent} from "./PipelineSaveEvent";
import {HttpClient} from "@angular/common/http";
import {filter} from "rxjs/operators";
import {PipelineErrorEvent} from "./PipelineErrorEvent";

@Component({
    selector: "pipeline-save-modal",
    templateUrl: "./pipeline.save.modal.component.html",
    styleUrls: [ "./pipeline.component.scss"]
})
export class PipelineSaveModalComponent  {

    public activateModal = false;
    public message = "Please Wait...";
    public detail = "";
    public isError = false;
    public entertainment: string;

    constructor(
        private http:HttpClient,
        private eventBus: EventBus,
        private modalConfig: ModalConfig,
        private logService: BugsnagLoggingService,
        private _ngZone: NgZone
    ) {

        this.subscribeObserve();
    }

    private subscribeObserve(): void {
        this.eventBus.pipe(filter((e: PipelineSaveEvent) =>
                (e.type === PipelineSaveEvent.TYPE)))
            .subscribe((e: PipelineSaveEvent) => {
                switch (e.status) {
                    case PIPELINE_API_STATUS.start:
                    case PIPELINE_API_STATUS.startglossary:
                        this.isError = false;
                        this.message = "Please Wait";
                        this.detail = "";
                        this.activateModal = true;
                        break;
                    case PIPELINE_API_STATUS.finishglossary:
                    case PIPELINE_API_STATUS.finish:
                        if (!this.isError) {
                            this.activateModal = false;
                        }
                        break;
                }
                console.log("Showing modal: " + this.activateModal);
            });
        this.eventBus.pipe(filter((e: PipelineErrorEvent) =>
            (e.type === PipelineErrorEvent.TYPE)))
            .subscribe((e: PipelineErrorEvent) => {
                this.activateModal = true;
                this.isError = true;
                this.message = "Error";
                this.detail = e.message;
                console.log("Showing error modal: ");
            });

        this.eventBus.pipe(filter((e) => true
            ))
            .subscribe((e) => {
                console.log("Got event ");
                console.log(e);
            });
    }

    public closeModal(): void {
        this.activateModal = false;
    }
}
